<template>
  <div class="bankPhoneField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value">
      <input
        @input="onInput"
        type="number"
        pattern="\d*"
        oninput="value=value.replace(/[^\d]/g,'')"
        v-model="phone"
        placeholder="请输入"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BankPhoneField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      phone: "",
    };
  },
  async mounted() {},
  methods: {
    onInput(val) {
      if (val.target.value.length > 11) {
        this.phone = val.target.value.slice(0, 11);
      }
      this.$emit("input", this.phone);
    },
  },
  watch: {
    value(newVal) {
      this.phone = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.bankPhoneField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 70px;
  .required {
    color: #ff4444;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0px 12px;
  border-radius: 17px;
  background: #f8f8f8;
  input {
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #333333;
    height: 100%;
    &::placeholder {
      color: rgba(170, 170, 170, 0.67);
    }
  }
  img {
    height: 16px;
  }
}
</style>
